<template>
  <main class="main-layout">
    <title-header/>
    <router-view></router-view>
    <div class="tabs">
      <ul>
        <router-link tag="li" :to="{name: 'works'}">
          <div class="icon">
            <component :is="worksIcon"/>
          </div>作品
        </router-link>
        <router-link tag="li" :to="{name: 'course'}">
          <div class="icon">
            <component :is="courseIcon"/>
          </div>课程
        </router-link>
        <router-link tag="li" :to="{name: 'report'}">
          <div class="icon">
            <component :is="reportIcon"/>
          </div>报告
        </router-link>
        <router-link tag="li" :to="{name: 'user'}">
          <div class="icon">
            <component :is="userIcon"/>
          </div>我的
        </router-link>
      </ul>
    </div>
  </main>
</template>
<script>
import WorksIcon from '@/assets/svg/tabs/works.svg'
import WorksActiveIcon from '@/assets/svg/tabs/works_active.svg'
import CourseIcon from '@/assets/svg/tabs/course.svg'
import CourseActiveIcon from '@/assets/svg/tabs/course_active.svg'
import ReportIcon from '@/assets/svg/tabs/report.svg'
import ReportActiveIcon from '@/assets/svg/tabs/report_active.svg'
import UserIcon from '@/assets/svg/tabs/user.svg'
import UserActiveIcon from '@/assets/svg/tabs/user_active.svg'
import TitleHeader from '@/widgets/TitleHeader'
export default {
  name: 'Main',
  computed: {
    worksIcon() {
      const name = this.$route.name
      return name === 'worksList' || name === 'worksReport'
        ? WorksActiveIcon
        : WorksIcon
    },
    courseIcon() {
      const name = this.$route.name
      return name === 'course' ? CourseActiveIcon : CourseIcon
    },
    reportIcon() {
      const name = this.$route.name
      return name === 'report' ? ReportActiveIcon : ReportIcon
    },
    userIcon() {
      const name = this.$route.name
      return name === 'user' ? UserActiveIcon : UserIcon
    }
  },
  watch: {
    '$route': {
      handler (val) {
        if (!val) return
        this.$store.dispatch('reportClassroomPageVisitParents')
      },
      immediate: true
    }
  },
  components: {
    TitleHeader
  }
}
</script>
<style lang="stylus" scoped>
.tabs
  position fixed
  z-index 6
  background-color white
  bottom 0
  left 0
  width 100%
  svg
    vertical-align middle
  ul
    display flex
    // border-1('%23d8d8d8', top)
    border-top 1px solid #d8d8d8
  li
    height 48px
    flex-column-center()
    flex-grow 1
    font-size 10px
    color #BBB
  .icon
    width 22px
    height 22px
  .link-active, .active
    color $themeColor
</style>
